import { render, staticRenderFns } from "./ProductRequestModal.vue?vue&type=template&id=b18507f4"
import script from "./ProductRequestModal.vue?vue&type=script&lang=js"
export * from "./ProductRequestModal.vue?vue&type=script&lang=js"
import style0 from "./ProductRequestModal.vue?vue&type=style&index=0&id=b18507f4&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b18507f4')) {
      api.createRecord('b18507f4', component.options)
    } else {
      api.reload('b18507f4', component.options)
    }
    module.hot.accept("./ProductRequestModal.vue?vue&type=template&id=b18507f4", function () {
      api.rerender('b18507f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/components/ProductRequestModal.vue"
export default component.exports